module.exports = "/_next/static/images/fc557554190736ad96923fa11a4bc7c6-app-screenshots-lg@2x.jpg";